export const SET_TOPICS = 'setTopics'
export const SET_STATE_FIELD = 'setStateField'
export const SET_ERRORS = 'setErrors'
export const REMOVE_ERROR = 'removeError'
